function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Scout",
  transform: "translate(-1 -0.993)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_305",
  "data-name": "Path 305",
  d: "M31.054,7.783a6.78,6.78,0,0,0-13.492-.969H3.424A2.427,2.427,0,0,0,1,9.237v19.39a2.427,2.427,0,0,0,2.424,2.424h19.39a2.427,2.427,0,0,0,2.424-2.424V27.084a1.454,1.454,0,0,0,.969-1.365V16.993a.485.485,0,0,0-.485-.485V14.4a6.814,6.814,0,0,0,5.332-6.621ZM4.878,30.081a8.237,8.237,0,0,1,6.707-8.047.485.485,0,0,0,.074-.933,4.3,4.3,0,0,1-2.852-4.213A4.371,4.371,0,0,1,13,12.727a4.314,4.314,0,0,1,1.58,8.372.485.485,0,0,0,.073.933,8.244,8.244,0,0,1,6.708,8.049Zm19.39-1.454a1.454,1.454,0,0,1-1.454,1.454h-.485a9.214,9.214,0,0,0-6.24-8.67,5.285,5.285,0,0,0-3.116-9.653,5.354,5.354,0,0,0-5.135,5.1,5.268,5.268,0,0,0,2.305,4.557,9.21,9.21,0,0,0-6.235,8.671H3.424a1.454,1.454,0,0,1-1.454-1.454V9.237A1.454,1.454,0,0,1,3.424,7.783H17.481a6.8,6.8,0,0,0,5.332,6.626v2.1a.485.485,0,0,0-.485.485v8.725a1.454,1.454,0,0,0,1.454,1.454h.485Zm.969-2.908a.485.485,0,0,1-.485.485h-.969a.485.485,0,0,1-.485-.485V17.478h1.939Zm-1.454-9.21V14.57h.969v1.939Zm.933-2.926h-.008c-.145.014-.291.017-.44.017a5.823,5.823,0,0,1-5.817-5.816,3.442,3.442,0,0,1,.021-.426V7.345s0-.007,0-.011a5.815,5.815,0,1,1,6.241,6.248Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M43.847,5a4.847,4.847,0,1,0,4.847,4.847A4.847,4.847,0,0,0,43.847,5Zm0,8.725a3.878,3.878,0,1,1,3.878-3.878,3.878,3.878,0,0,1-3.878,3.878Z",
  transform: "translate(-19.58 -2.064)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_307",
  "data-name": "Path 307",
  d: "M45.908,9A2.911,2.911,0,0,0,43,11.908a.485.485,0,0,0,.969,0,1.939,1.939,0,0,1,1.939-1.939.485.485,0,1,0,0-.969Z",
  transform: "translate(-21.641 -4.125)",
  fill: "#ac1ede"
}));

var SvgScout = function SvgScout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.054,
    height: 30.058,
    viewBox: "0 0 30.054 30.058",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scout.55e285e5.svg";
export { ForwardRef as ReactComponent };